import { CREATE_USERFORM_BILL_RECEIVING_REPORT, FETCH_BILL_RECEIVING_REPORT_CONSOLIDATE_DATA_FAILURE, FETCH_BILL_RECEIVING_REPORT_CONSOLIDATE_DATA_REQUEST, FETCH_BILL_RECEIVING_REPORT_CONSOLIDATE_DATA_SUCCESS, FETCH_BILL_RECEIVING_REPORT_DATA_FAILURE, FETCH_BILL_RECEIVING_REPORT_DATA_REQUEST, FETCH_BILL_RECEIVING_REPORT_DATA_SUCCESS, SET_RENDER_TAB_DATA } from "./billReceivingReport.actionType";


export const BILL_RECEIVING_REPORT = 'billReceivingReport';

let initialState = {
    loading: false,
    billReceivingReportData: [],
    billReceivingReportConsolidate: [],
    userform: {
        startDate: new Date().setDate(new Date().getDate() - 15),
        endDate: new Date(),
        fldFKProgram: '',
    },
    errorMessage: '',
    activeKey: 1,
    renderTab: 'Summary'
}

export let billReceivingReportReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_BILL_RECEIVING_REPORT_DATA_REQUEST:
        case FETCH_BILL_RECEIVING_REPORT_CONSOLIDATE_DATA_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case FETCH_BILL_RECEIVING_REPORT_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                billReceivingReportData: updatePayload.BED
            }
        case FETCH_BILL_RECEIVING_REPORT_CONSOLIDATE_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                billReceivingReportConsolidate: updatePayload.BED
            }
        case CREATE_USERFORM_BILL_RECEIVING_REPORT:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            }
        case FETCH_BILL_RECEIVING_REPORT_DATA_FAILURE:
        case FETCH_BILL_RECEIVING_REPORT_CONSOLIDATE_DATA_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case SET_RENDER_TAB_DATA:
            return {
                ...state,
                loading: false,
                renderTab: payload
            };
        default:
            return state;
    }
}